import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../../../../../../../../../state/app.state';
import { workConditions } from '../../../../../../../../../../shared/core/shared.selectors';
import { DailyReportService } from '../../../../daily-report.service';
import { ProjectsService } from '../../../../../../../../core/projects.service';
import { Ability, subject } from '@casl/ability';
import { dailyReport } from '../../../../../../../../core/projects.selectors';

@Component({
    selector: 'app-workday-details-wrapper',
    templateUrl: './workday-details-wrapper.component.html',
    styleUrls: ['./workday-details-wrapper.component.scss'],
    standalone: false
})
export class WorkdayDetailsWrapperComponent implements OnInit, OnDestroy {
  @Input() data: any;
  workdayOptions: any[] = [];
  nonWorkdayOptions: any[] = [];
  editable = false;
  dailyReportData: any;

  form = new FormGroup<any>({
    dayType: new FormControl({ value: null, disabled: false }),
    note: new FormControl(''),
  });

  formSubscription: Subscription = new Subscription();
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private store: Store<fromRoot.State>,
    private dailyReportService: DailyReportService,
    private projectsService: ProjectsService,
    private ability: Ability,
  ) {}

  ngOnInit() {
    this.store.select(dailyReport)
      .pipe(takeUntil(this.onDestroy))
      .subscribe((report: any) => {
        this.dailyReportData = { ...report };
        this.editable = this.ability.can('create', subject('DailyReport', this.dailyReportData));
        if (!this.editable) {
          this.form.disable({ emitEvent: false });
        } else {
          this.form.enable({ emitEvent: false });
        }
      });

    this.store.select(workConditions)
      .pipe(takeUntil(this.onDestroy))
      .subscribe((data) => {
        // Workday is code 999
        this.workdayOptions = data.filter(o => o.value === 999);
        // Everything else is non-workday
        this.nonWorkdayOptions = data.filter(o => o.value !== 999);
      });

    // Set initial values from data
    if (this.data) {
      this.form.controls.dayType.setValue(this.data.work_condition_code, { emitEvent: false });
      this.form.controls.note.setValue(this.data.work_condition_comment || '', { emitEvent: false });
    }

    this.formSubscription = this.form.valueChanges
      .pipe(takeUntil(this.onDestroy))
      .subscribe(() => {
        if (this.editable) {
          this.projectsService.isAnyFormDirty.next(true);
        }
      });

    this.dailyReportService.triggerSave
      .pipe(takeUntil(this.onDestroy))
      .subscribe(() => {
        this.save();
      });
  }

  save() {
    const { dayType, note } = this.form.getRawValue();

    this.dailyReportService.save.next({
      type: 'workday',
      data: {
        work_condition_code: dayType,
        work_condition_comment: note || null,
      },
      options: {},
    });
  }

  ngOnDestroy() {
    this.formSubscription?.unsubscribe();
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
